import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs/Subscription';
import { UserService } from "../../../../injections/user.service";
import * as jsPDF from 'jspdf'
import { AuthService } from "../../../../injections/auth.service";

declare var $:any;
@Component({
    selector: 'modal-bill',
    templateUrl: '../../templates/partials/modal-bill.html'
})
export class ModalBillComponent implements OnInit {

    @Input() showModal;
    @Input() data;
    @ViewChild('billModal') public billModal:ModalDirective;
    @Output() hideModalEmitter = new EventEmitter();
    public subscription: Subscription;
    constructor(private _user: UserService) { }

    public onHidden():void{
        this.hideModalEmitter.emit();
    }
    
    ngOnChanges() {
        if(this.data != null && this.data.service.fee != 0){
            this.data.service.total_amount_real = parseFloat(this.data.service.total_amount_real) + this.data.service.fee;
            this.data.service.total_amount_real = this.data.service.total_amount_real.toFixed(2);
        }
        (this.showModal) ? this.billModal.show() : this.billModal.hide();;
    }

    public closeModal():void{
        this.hideModalEmitter.emit();
    }

    public generatePdf() {
        var bill = document.getElementById("printableSection");
        var pdf = new jsPDF('a4');
        var w = bill.clientWidth;
        var h = bill.clientHeight;
        let data = this.data;

        var newCanvas = document.createElement('canvas');
        newCanvas.width = w * 2;
        newCanvas.height = h * 2;
        newCanvas.style.width = w + 'px';
        newCanvas.style.height = h + 'px';
        var context = newCanvas.getContext('2d');
        // -w + 240 && -h + 219
        var percentWidth = ($('body').width() - newCanvas.width) + w;
        var percentHeight = ($('#serviceBillModal').height() - newCanvas.height) + h - 88;

        context.setTransform(2, 0, 0, 2,-percentWidth, -percentHeight);

        pdf.addHTML(bill, {canvas:newCanvas}, ()=>
        {
            let name = "Factura_" + data.client.client_name + "_" + data.client.client_surname + "_" + data.service.date + ".pdf";
            pdf.save(name);
            this.hideModalEmitter.emit();
            //let base64 = pdf.output("datauristring");
        })

    }

    public sendPdf(){

        var bill = document.getElementById("printableSection");
        var pdf = new jsPDF('a4');
        var w = bill.clientWidth;
        var h = bill.clientHeight;
        let base64;
        let dataS = this.data;

        var newCanvas = document.createElement('canvas');
        newCanvas.width = w * 2;
        newCanvas.height = h * 2;
        newCanvas.style.width = w + 'px';
        newCanvas.style.height = h + 'px';
        var context = newCanvas.getContext('2d');
        // -w + 240 && -h + 219
        var percentWidth = ($('body').width() - newCanvas.width) + w;
        var percentHeight = ($('#serviceBillModal').height() - newCanvas.height) + h - 88;

        context.setTransform(2, 0, 0, 2,-percentWidth, -percentHeight);

        pdf.addHTML(bill, {canvas:newCanvas}, ()=>
        {
            base64 = pdf.output("datauristring");
            var data = {
                pdf:        base64,
                mail_to:    "luis@clintu.es",
                date:       dataS.service.date,
                name:       dataS.client.client_name,
                surname:    dataS.client.client_surname,
                id_service: dataS.service.id_service,
            }
            this._user.sendMailBill(data).subscribe(result => {
                console.log(result);
            });

        })
    }

  
    ngOnInit() {
     }
}


// WEBPACK FOOTER //
// ./src/app/modules/users/components/dummy/modal-bill.component.ts